import { ThemeMode } from "@lib/constants/AppEnums";
import ReactJson, { ReactJsonViewProps } from "react-json-view";
import { useTheme } from "styled-components";

type Props = ReactJsonViewProps & {
  theme?: ThemeMode;
};

const AppJson: React.FC<Props> = (props) => {
  const { mode } = useTheme();
  const { theme = mode } = props;

  const darkMode: ReactJsonViewProps["theme"] = "threezerotwofour";
  const lightMode: ReactJsonViewProps["theme"] = "rjv-default";

  const themeMode = theme === ThemeMode.DARK ? darkMode : lightMode;

  return <ReactJson theme={themeMode} name={null} {...props} />;
};

export default AppJson;
